import React from 'react';
import { reduxForm, Field } from 'redux-form';
import CheckboxField from '../../../CheckboxField';
import FormError from '../../../FormError';

let ModifyAutoRenewForm = ({ handleSubmit, error }) => (
  <form onSubmit={handleSubmit}>
    <Field
      component={CheckboxField}
      name="renewal_enabled"
      label="Auto Renew"
    />
    {error && <FormError error={error} />}
    <br />
    <button className="btn btn-primary">Change Auto Renew</button>
  </form>
);

ModifyAutoRenewForm = reduxForm({
  form: 'autoRenew',
  enableReinitialize: true,
})(ModifyAutoRenewForm);

export default ModifyAutoRenewForm;
